import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class AbstractAction extends AbstractProvidedClass {
    constructor(provider) {
        super(provider);
    }

    update() {

    }

    discard() {
        this.actions.discard();
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        throw new Error("Not implemented");
    }

    redo() {
        throw new Error("Not implemented");
    }
}
